@for (item of vaps; track item; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox"
          [checked]="item?.checked"
          (click)="checkAddon(i)"
          [id]="'checkbox' + currentVap?.product_vaps_id + '-' + item?.session_item_id"
          [class]="'addon-' + currentVap?.product_vaps_id" />
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + item?.session_item_id"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !item?.show}"
          data-toggle="collapse"
          style="cursor:default"
          (click)="$event.preventDefault()"
          aria-expanded="false">
          <h6>{{item?.description?.length ? item?.description[2] : ''}}</h6>
          <div class="addon-expander__cost" [ngClass]="{'is-active': item?.is_active}">
            <p>
              <strong [class]="currentVap?.product_vaps_id + '-' + item?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + ' addon-' + currentVap?.product_vaps_id">
                {{item?.price | currency:'ZAR':'R ':'1.0-0'}}
              </strong> /mo
            </p>
          </div>
          <div class="addon-expander__caret">
            <svg class="icon">
              <use xlink:href="#dropdown"></use>
            </svg>
          </div>
        </a>
      </div>
      <div class="addon-expander__content collapse"
        [ngClass]="{'show': item?.show}"
        [id]="'addon-vehicle-field-' + item?.session_item_id">
        <div class="modal-addons__item">
          <div class="form-group">
            <label [for]="question?.cent_aq_question_id">{{question?.question_copy}}</label>
            <input
              type="number"
              [class]="'form-control answers ' + question?.cent_aq_question_id"
              [(ngModel)]="item.detail2"
              (ngModelChange)="onChange(i, 0)"
              [placeholder]="question?.question_prompt"/>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="modal fade modal--alert" id="error-alert-modal" tabindex="-1" role="dialog" aria-labelledby="error-alert-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert">

          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar">
                <img [src]="'assets/' + sessionDetails.category_id + '/avatar/unsure.png'" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal" onclick="return false;">
                <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h4>Oops!</h4>
                <p class="alert-text">You have selected a value above maximum allowed<br> ({{currentVap?.value_max | currency:'ZAR':'R ':'1.0-0'}})</p>
              </div>

              <div class="modal-alert__content-btn">
                <a href="#" class="button button--lg button--primary remove-dismiss" data-dismiss="modal">Ok</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
